var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 610,
    height: 193,
    viewBox: "0 0 610 193",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4045_2491",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9721 24.8389C22.8253 12.219 32.3716 0 45.378 0H590C601.046 0 610 8.95431 610 20V173C610 184.046 601.046 193 590 193H83.5294C74.3475 193 66.3451 186.748 64.1235 177.839L25.9721 24.8389ZM0.0737305 0.145481C0.0332031 0.146042 0 0.113313 0 0.072744C0 0.0325686 0.0325928 0 0.0727539 0H10.5981L0.0737305 0.145481Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9721 24.8389C22.8253 12.219 32.3716 0 45.378 0H590C601.046 0 610 8.95431 610 20V173C610 184.046 601.046 193 590 193H83.5294C74.3475 193 66.3451 186.748 64.1235 177.839L25.9721 24.8389ZM0.0737305 0.145481C0.0332031 0.146042 0 0.113313 0 0.072744C0 0.0325686 0.0325928 0 0.0727539 0H10.5981L0.0737305 0.145481Z",
    fill: "white",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5981 0V-1L10.6119 0.999904L10.5981 0ZM0.0737305 0.145481L0.0875854 1.14539L0.0737305 0.145481ZM64.1235 177.839L63.1533 178.081L64.1235 177.839ZM25.9721 24.8389L26.9424 24.597L25.9721 24.8389ZM590 1H45.378V-1H590V1ZM609 173V20H611V173H609ZM83.5294 192H590V194H83.5294V192ZM63.1533 178.081L25.0018 25.0809L26.9424 24.597L65.0939 177.597L63.1533 178.081ZM10.5981 1H0.0727539V-1H10.5981V1ZM10.6119 0.999904L0.0875854 1.14539L0.0599365 -0.854424L10.5844 -0.999904L10.6119 0.999904ZM1 0.072744C1 -0.444369 0.577026 -0.861571 0.0599365 -0.854424L0.0875854 1.14539C-0.51062 1.15365 -1 0.670994 -1 0.072744H1ZM-1 0.072744C-1 -0.519726 -0.519714 -1 0.0727539 -1V1C0.584839 1 1 0.584863 1 0.072744H-1ZM83.5294 194C73.8884 194 65.4859 187.435 63.1533 178.081L65.0939 177.597C67.2043 186.061 74.8066 192 83.5294 192V194ZM611 173C611 184.598 601.598 194 590 194V192C600.493 192 609 183.493 609 173H611ZM45.378 1C33.0219 1 23.9529 12.608 26.9424 24.597L25.0018 25.0809C21.6976 11.8299 31.7213 -1 45.378 -1V1ZM590 -1C601.598 -1 611 8.40203 611 20H609C609 9.50659 600.493 1 590 1V-1Z",
    fill: "#E2E8FF",
    fillOpacity: 0.8,
    mask: "url(#path-1-inside-1_4045_2491)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsDetails);
export default __webpack_public_path__ + "static/media/points_details.89692ecfbf7c28396e2765e95c4044eb.svg";
export { ForwardRef as ReactComponent };